import { IInventoryPage } from '../../../inventory-page.interface';


export const RESEARCH_KEYWORD_TAG_GENERATOR_PAGE: IInventoryPage = {
	'route': '/research/keyword/tag-generator',
	'title': 'Tag Generator',
	'uiReference': [
		'Enter a product niche or topic',
		'Copy keyword',
		'Relative occurrence strength',
		'All Keywords',
		'Short Tail Keywords',
		'Long Tail Keywords',
		'Scroll to top',
		'Marketplace',
		'Topic',
		'Generate tags',
		'Generated tags',
		'results',
		'Copy all',
		'Workbench',
		'Export',
		'Validate your best tags with Flying Research',
		'Compare search demand and competing products before choosing your final keywords.',
		'All tags',
		'Copy',
		'characters',
		'words',
		'keywords',
		'Short-tail tags',
		'Long-tail tags',
		'Not available in free version',
		'Oh man, the board seems to be not included in the free version',
		'Open in KW Workbench',
		'Copy to Clipboard'
	],
	'sources': [
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/tag-generator/tag-generator-routing.module.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/tag-generator/tag-generator.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/tag-generator/tag-generator.component.html',
		'apps/flying-projects/frontend/webapp/src/app/components/inform-cards/info-card/info-card.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/components/inform-cards/info-card/info-card.component.html',
		'apps/flying-projects/frontend/webapp/src/app/components/inform-cards/animated-card-loader/animated-card-loader.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/components/inform-cards/animated-card-loader/animated-card-loader.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/tables-and-helpers/kw-board/kw-board.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/tables-and-helpers/kw-board/kw-board.component.html'
	],
	'aliases': []
};
